import SectionHeading from "@/components/feature/SectionHeading";
import { communityTestimonials } from "@/mocks/site";

export default function TestimonialsSection() {
  return (
    <section className="w-full bg-background-50">
      <div className="max-w-content mx-auto px-4 md:px-8 py-14 md:py-20">
        <SectionHeading
          kicker="Community Voices"
          title="围观群众怎么说"
          desc="来自长期读者与投稿者的真实反馈，他们说得比我们写得好。"
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {communityTestimonials.map((item) => (
            <figure
              key={item.name}
              className="flex flex-col p-6 rounded-lg border border-background-200 bg-background-100"
            >
              <i className="ri-double-quotes-l text-3xl text-primary-300"></i>
              <blockquote className="mt-3 text-sm text-foreground-700 leading-relaxed flex-1">
                {item.text}
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-background-300/70 flex items-center gap-3">
                <span className="w-10 h-10 rounded-full bg-primary-500 text-background-50 flex items-center justify-center font-heading font-bold">
                  {item.name.slice(0, 1)}
                </span>
                <span className="min-w-0">
                  <span className="block text-sm font-medium text-foreground-900">{item.name}</span>
                  <span className="block text-xs text-foreground-500">{item.role}</span>
                </span>
                <span className="ml-auto shrink-0 px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-800 text-xs">
                  {item.tag}
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}